import React, { useState } from 'react';

import AccommodationSearchForm from '../AccommodationSearch/components/AccommodationSearchForm';

const API_DATE_FORMAT = 'YYYY-MM-DD';

const TravelSearchExternalForm = () => {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [popularDateValue, setPopularDateValue] = useState('default');

  function search(e) {
    e.preventDefault();

    const searchUrl = new URL(drupalSettings.travelsearch_page);

    searchUrl.searchParams.append(
      'startDate',
      startDate ? startDate.format(API_DATE_FORMAT) : ''
    );
    searchUrl.searchParams.append(
      'endDate',
      endDate ? endDate.format(API_DATE_FORMAT) : ''
    );
    searchUrl.searchParams.append('adults', adults);
    searchUrl.searchParams.append('children', children);
    if (popularDateValue !== 'default') {
      searchUrl.searchParams.append('popularDate', popularDateValue);
    }

    window.location.href = searchUrl;
  }

  return (
    <div className="travel-search-external-form">
      <AccommodationSearchForm
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        adults={adults}
        setAdults={setAdults}
        maxGuests={14}
        kids={children}
        setChildren={setChildren}
        setPopularDateValue={setPopularDateValue}
        onSubmit={search}
        buttonText={Drupal.t(
          'Search',
          {},
          { context: 'Travel search external' }
        )}
        availabilityFound={true}
        roomAllowsPets={false}
        allowInfants={false}
        selectDatesLabel={Drupal.t('Dates')}
        popularDatesLabel={Drupal.t('Or choose from quick links')}
        adultsLabel={Drupal.t('Adults')}
        kidsLabel={Drupal.t('Kids 0-12 yrs')}
        startDatePlaceholderText={Drupal.t('Arrival')}
        endDatePlaceholderText={Drupal.t('Departure')}
      />
    </div>
  );
};

export default TravelSearchExternalForm;
